import axios from '../plugins/axios'

export const getDashboardReport = (range, companyId) => axios.get('report/dashboard', {
  params: { range, companyId }
})

export const getPendingToFinish = () => axios.get('report/process/pendingToFinish')
export const getServicesByAnalyst = () => axios.get('report/servicesByAnalyst')

export const getProcessStatusSummary = (dateRangeType, companyId) => axios.get('/report/process/statusSummary', {
  params: {
    dateRangeType,
    companyId
  },
});

export const getStatusSummary = (dateRangeType, companyId) => {
  return axios.get('/report/process/chartData', {
    params: {
      dateRangeType,
      companyId
    }
  });
};

export const getServiceStatusSummary = (dateRangeType, companyId) => {
  return axios.get('/report/services/statusSummary', {
    params: {
      dateRangeType,
      companyId
    }
  });
};

export const getPieChartDataService = (dateRangeType, companyId) => {
  return axios.get('/report/services/processSummary', {
    params: {
      dateRangeType,
      companyId
    }
  });
};